import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { SuccessTemplateProps } from '../../../../templates/Success'
import { useDefaultLayoutProps } from '../../../../layouts/DefaultLayout/useProps'
import { selectors } from '../../../../redux'

export const useCancelSuccessProps = (): SuccessTemplateProps => {
  const { t } = useTranslation()
  const visitor = useSelector(selectors.app.visitor)
  const layout = useDefaultLayoutProps()

  return useMemo(
    () => ({
      layout,
      titleDescription: {
        title: t('cancelSuccess.title', {
          name: `${visitor?.first_name ?? ''} ${visitor?.last_name ?? ''}`.trim(),
        }),
        description: t('cancelSuccess.description', { event: visitor?.event?.name ?? '' }),
        isCentered: true,
      },
    }),
    [layout, t, visitor?.first_name, visitor?.last_name, visitor?.event?.name]
  )
}
